module.exports = __webpack_public_path__ + "assets/img/download-btn-75fcc8e5.png";